"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ErrorDetailComponent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _stylingConstants = require("../styling/stylingConstants");

var getClassNames = (0, _react.classNamesFunction)();

var ErrorDetailComponentBase = function ErrorDetailComponentBase(_ref) {
  var label = _ref.label,
      value = _ref.value,
      className = _ref.className,
      styles = _ref.styles,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth;
  var classes = getClassNames(styles, {
    isFullWidth: isFullWidth
  });

  if (value === undefined) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
    verticalAlign: "start",
    horizontalAlign: "start",
    className: (0, _react.css)(className, classes.root),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: classes.label,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: classes.value,
      children: value
    })]
  });
};

var ErrorDetailComponent = (0, _react.styled)(ErrorDetailComponentBase, function (_ref2) {
  var isFullWidth = _ref2.isFullWidth;
  return {
    root: {
      width: isFullWidth ? '100%' : '50%',
      paddingTop: _stylingConstants.gridUnit * 1,
      selectors: (0, _defineProperty2.default)({}, "@media(max-width: ".concat(_react.ScreenWidthMaxSmall, "px)"), {
        width: '100%'
      })
    },
    value: {
      fontSize: _react.FontSizes.medium,
      display: 'block',
      textAlign: 'left',
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    },
    label: {
      fontSize: _react.FontSizes.medium,
      display: 'block',
      textAlign: 'left',
      color: '#666666',
      fontWeight: 'bold'
    }
  };
});
exports.ErrorDetailComponent = ErrorDetailComponent;